import { CalendarClock } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SportEmoji from "@/components/SportEmojis";
import type { SportType } from "@/types";

const sports: Array<{ id: SportType; name: string; path: string }> = [
  { id: "soccer", name: "Soccer", path: "/sport/soccer/upcoming" },
  { id: "nba", name: "NBA", path: "/sport/nba/upcoming" },
  { id: "nfl", name: "NFL", path: "/sport/nfl/upcoming" },
  { id: "mlb", name: "MLB", path: "/sport/mlb/upcoming" },
  { id: "nhl", name: "NHL", path: "/sport/nhl/upcoming" },
];

export default function UpcomingHub() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <Header />
      <main id="main-content" className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
        <div className="flex items-center gap-3">
          <CalendarClock className="h-7 w-7 text-indigo-300" />
          <h1 className="text-3xl font-bold">Upcoming games</h1>
        </div>
        <p className="mt-3 max-w-xl text-slate-400">
          Choose a sport, then save a game to your private replay plan.
        </p>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2" role="list">
          {sports.map(({ id, name, path }) => (
            <li key={path}>
              <Link
                to={path}
                className="flex min-h-16 items-center justify-between rounded-2xl border border-white/10 bg-slate-900 px-5 font-semibold hover:border-indigo-400/50 hover:bg-slate-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-300"
              >
                <span className="flex items-center gap-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-slate-950/70 ring-1 ring-white/10">
                    <SportEmoji sportType={id} size="medium" />
                  </span>
                  <span>{name}</span>
                </span>
                <span aria-hidden="true">→</span>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  );
}
